<script>
/**
 * @overview 场景管理 - 编辑
 *
 * @author huojinzhao
 */

import mapUtils, { $form, $http } from "@/utils";

export default {
  name: "ThemeEdition",

  data: () => ({
    // 当前选中编辑的主题部分
    activePart: "menu",

    parts: [
      {
        label: "菜单主题",
        index: "menu",
        content: [
          {
            label: "home图标",
            index: "home.icon",
          },
          {
            label: "home标语",
            index: "home.title",
          },
          {
            label: "warmup图标",
            index: "warmup.icon",
          },
          {
            label: "warmup标语",
            index: "warmup.title",
          },
          {
            label: "learn图标",
            index: "learn.icon",
          },
          {
            label: "learn标语",
            index: "learn.title",
          },
          {
            label: "game图标",
            index: "game.icon",
          },
          {
            label: "game标语",
            index: "game.title",
          },
          {
            label: "summary图标",
            index: "summary.icon",
          },
          {
            label: "summary标语",
            index: "summary.title",
          },
          {
            label: "celebrate图标",
            index: "celebrate.icon",
          },
          {
            label: "celebrate标语",
            index: "celebrate.title",
          },
        ],
      },
      {
        label: "默认主题",
        index: "scene",
        content: [
          {
            label: "home环节前景",
            index: "home.foreground",
          },
          {
            label: "home环节后景",
            index: "home.background",
          },
          {
            label: "warmup环节前景",
            index: "warmup.foreground",
          },
          {
            label: "warmup环节后景",
            index: "warmup.background",
          },
          {
            label: "learn环节前景",
            index: "learn.foreground",
          },
          {
            label: "learn环节后景",
            index: "learn.background",
          },
          {
            label: "game环节前景",
            index: "game.foreground",
          },
          {
            label: "game环节后景",
            index: "game.background",
          },
          {
            label: "summary环节前景",
            index: "summary.foreground",
          },
          {
            label: "summary环节后景",
            index: "summary.background",
          },
          {
            label: "celebrate环节前景",
            index: "celebrate.foreground",
          },
          {
            label: "celebrate环节后景",
            index: "celebrate.background",
          },
        ],
      },
      {
        label: "按钮主题",
        index: "director",
        content: [
          {
            label: "后退图标",
            index: "backward",
          },
          {
            label: "前进图标",
            index: "forward",
          },
          {
            label: "暂停图标",
            index: "pause",
          },
          {
            label: "播放图标",
            index: "start",
          },
        ],
      },
      {
        label: "闪卡主题",
        index: "card",
        content: [
          {
            label: "卡片正面",
            index: "front",
          },
          {
            label: "卡片背面",
            index: "reverse",
          },
        ],
      },
      {
        label: "学生主题",
        index: "student",
        content: [
          {
            label: "默认头像",
            index: "avatar",
          },
        ],
      },
      {
        label: "排名主题",
        index: "rank",
        content: [
          {
            label: "练习排名板",
            index: "practice.panel",
          },
          {
            label: "练习分数槽",
            index: "practice.groove",
          },
          {
            label: "结算排名板",
            index: "celebrate.panel",
          },
          {
            label: "结算分数槽",
            index: "celebrate.groove",
          },
        ],
      },
    ],

    name: "",

    theme: {
      menu: {
        home: {
          icon: "",
          title: "",
        },
        warmup: {
          icon: "",
          title: "",
        },
        learn: {
          icon: "",
          title: "",
        },
        game: {
          icon: "",
          title: "",
        },
        summary: {
          icon: "",
          title: "",
        },
        celebrate: {
          icon: "",
          title: "",
        },
      },

      director: {
        backward: "",
        forward: "",
        pause: "",
        start: "",
      },

      scene: {
        home: {
          foreground: "",
          background: "",
        },
        warmup: {
          foreground: "",
          background: "",
        },
        learn: {
          foreground: "",
          background: "",
        },
        game: {
          foreground: "",
          background: "",
        },
        summary: {
          foreground: "",
          background: "",
        },
        celebrate: {
          foreground: "",
          background: "",
        },
      },

      card: {
        front: "",
        reverse: "",
      },

      student: {
        avatar: "",
      },

      rank: {
        practice: {
          panel: "",
          groove: "",
        },
        celebrate: {
          panel: "",
          groove: "",
        },
      },
    },

    rules: {
      name: [
        $form.rules.required("场景名称"),
      ],
    },

    imagePattern: /\.(png|jpe?g|gif|svg)(\?.*)?$/,

    loading: {
      init: false,
      submit: false,
    },
  }),

  computed: {
    activePartContent() {
      return this.parts
        .find(({ index }) => index === this.activePart)
        .content;
    },
  },

  created() {
    this.$route.params.id
      && this.init(this.$route.params.id);
  },

  methods: {
    ...mapUtils("form", ["submit", "errorAlert"]),

    init(id) {
      this.loading.init = true;

      $http.get(`/theme/${id}`)
        .then(({ name, json_config_original }) => {
          this.name = name;
          this.theme = json_config_original;
        })
        .finally(() => {
          this.loading.init = false;
        });
    },

    findModelLocation(index) {
      const keys = index.split(".");

      return [this.activePart, ...keys];
    },

    modelCheckout(index) {
      const keys = this.findModelLocation(index);

      return keys.reduce((acc, key) => acc[key], this.theme);
    },

    modelCheckin(value, index) {
      const keys = this.findModelLocation(index);

      const lastKey = keys.pop();

      const pointer = keys
        .reduce((acc, key) => acc[key], this.theme);

      pointer[lastKey] = value;
    },

    cancel() {
      this.$router.back();
    },

    validate() {
      this.$refs.form.validate(valid => valid && this.submit());
    },

    submit() {
      this.loading.submit = true;

      const images = this.produceImageList(this.theme);

      const data = {
        name: this.name,
        images,
        json_config_original: this.theme,
        type_id: this.$route.query.type,
      };
      this.$form_submit({
        id: Number(this.$route.params.id),
        data,
        uri: "/theme",
      })
        .then(this.cancel)
        .catch(this.$form_errorAlert)
        .finally(() => {
          this.loading.submit = false;
        });
    },

    produceImageList(data) {
      if (data instanceof Object) {
        return Object.keys(data)
          .reduce((acc, key) => [
            ...acc,
            ...this.produceImageList(data[key]),
          ], []);
      }

      const condition =
        typeof data === "string" && this.imagePattern.test(data);

      return condition ? [data] : [];
    },
  },
};
</script>

<template>
  <div
    v-loading="loading.init"
    class="theme-edition"
  >
    <div class="search-box">
      <el-form
        ref="form"
        :model="{ name }"
        :rules="rules"
        inline
      >
        <el-form-item
          label="场景名称"
          prop="name"
        >
          <el-input
            v-model="name"
            placeholder="请输入场景名称"
          />
        </el-form-item>
      </el-form>

      <AppFormSubmit
        :submitting="loading.submit"
        @submit="validate"
        @cancel="cancel"
      />
    </div>
    <div class="menu-box">
      <v-radio-text
        v-model="activePart"
        :list="parts"
        value-key="index"
      />
    </div>

    <div class="theme-edition__body">
      <div
        v-for="item in activePartContent"
        :key="item.index"
        class="theme-edition__body-item"
      >
        <AppQiniu
          :value="modelCheckout(item.index)"
          type="image"
          token-url="/upload/token"
          token-mode="type"
          preview
          @input="value => modelCheckin(value, item.index)"
        />
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.theme-edition {
  //flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.search-box{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 30px;
}
.search-box .el-form-item{
  margin-bottom: 0px;
}
.menu-box{
  padding: 0px 30px;
}
.theme-edition .el-form {
  padding: 1em;
}
.theme-edition__body {
  display: flex;
  flex-wrap: wrap;
  //flex-grow: 1;
  align-content: center;
  align-items: center;
  justify-content: center;
}
.theme-edition__body-item {
  display: flex;
  flex-direction: column;
  margin: 20px;
}
.theme-edition__body-item > span {
  width: 100%;
  padding: 5px 0;
  text-align: center;
  color: var(--font-color-secondary);
}
.theme-edition .layout-the-footer {
  justify-content: space-between;
}
</style>
